import { createSlice } from '@reduxjs/toolkit'
import {
  MarketplaceCategory,
  MarketplaceStoreName,
  DefaultOrderCategoryLogistic,
  DefaultOrderCategoryMarketplace,
  DefaultOrderCategoryWebsite,
  IsLoadConfigurationAction,
  IsSaveConfigurationAction,
  IsSaveDefaultConfigurationsAction,
  IsDeleteConfigurationAction,
  IsRenameConfigurationAction,
  configurationMarketplaceCategorySort,
} from '../../Constants/Configuration'
import { WorkSpaces } from '../../Constants/WorkSpace'
import {
  decryptLocalStorageValue,
  encryptLocalStorageValue,
  getStorageValue,
  removeStorageValue,
  setStorageValue,
} from '../../Helpers/ConfigurationHelper'

const marketplaceColumns = [
  {
    key: MarketplaceCategory,
  },
]

const marketplaceStoreColumns = [
  {
    key: MarketplaceStoreName,
  },
]

const marketplaceSpecificStoresColumns = [
  {
    key: MarketplaceStoreName,
  },
]

const categorySortOrder = [DefaultOrderCategoryMarketplace, DefaultOrderCategoryWebsite, DefaultOrderCategoryLogistic]

export const marketplaceAvailabilitiesSlice = createSlice({
  name: 'marketplaceAvailabilities',
  initialState: {
    value: {
      marketplaceColumns: marketplaceColumns,
      marketplaceStoreColumns: marketplaceStoreColumns,
      marketplaceSpecificStoresColumns: marketplaceSpecificStoresColumns,
      categorySortOrder: categorySortOrder,
    },
  },
  reducers: {
    setCategorySortOrder: (state, action) => {
      state.value.categorySortOrder = action.payload
    },
  },
  extraReducers: builder => {
    builder
      .addMatcher(IsLoadConfigurationAction, (state, action) => {
        const stored = decryptLocalStorageValue(
          action.payload.configurationName + configurationMarketplaceCategorySort,
          action.payload.user,
          action.payload.serverConfig,
        )
        state.value.categorySortOrder = stored ? JSON.parse(stored) : categorySortOrder
      })
      .addMatcher(IsSaveConfigurationAction, (state, action) => {
        encryptLocalStorageValue(
          action.payload.currentConfiguration + configurationMarketplaceCategorySort,
          JSON.stringify(state.value.categorySortOrder),
          action.payload.user,
          action.payload.serverConfig,
        )
      })
      .addMatcher(IsSaveDefaultConfigurationsAction, (state, action) => {
        if (action.payload.publicWorkspace) {
          const space = WorkSpaces[action.payload.publicWorkspace]
          encryptLocalStorageValue(
            action.payload.publicWorkspace + configurationMarketplaceCategorySort,
            JSON.stringify(space[configurationMarketplaceCategorySort.substring(1)]),
            action.payload.user,
            action.payload.serverConfig,
          )
        } else {
          for (const [key, value] of Object.entries(WorkSpaces)) {
            encryptLocalStorageValue(
              key + configurationMarketplaceCategorySort,
              JSON.stringify(value[configurationMarketplaceCategorySort.substring(1)]),
              action.payload.user,
              action.payload.serverConfig,
            )
          }
        }
      })
      .addMatcher(IsDeleteConfigurationAction, (state, action) => {
        removeStorageValue(
          action.payload.configurationName + configurationMarketplaceCategorySort,
          action.payload.user,
          action.payload.serverConfig,
        )
      })
      .addMatcher(IsRenameConfigurationAction, (state, action) => {
        const value = getStorageValue(
          action.payload.before + configurationMarketplaceCategorySort,
          action.payload.user,
          action.payload.serverConfig,
        )

        setStorageValue(
          action.payload.after + configurationMarketplaceCategorySort,
          action.payload.user,
          action.payload.serverConfig,
          value,
        )

        removeStorageValue(
          action.payload.before + configurationMarketplaceCategorySort,
          action.payload.user,
          action.payload.serverConfig,
        )
      })
  },
})

export const { setCategorySortOrder } = marketplaceAvailabilitiesSlice.actions

export default marketplaceAvailabilitiesSlice.reducer
